<template>
    <div class="w-full">
        <div class="pt-2 md:pt-4">
            <div class="w-full">
                <a-table
                    data-cy="vehicle-list"
                    :columns="getColumns"
                    :dataSource="table_data"
                    :rowKey="(record) => record.id"
                    :pagination="false"
                    :locale="locale"
                    size="middle"
                    class="ant-table-striped"
                >
                </a-table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        table_data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            locale: {
                emptyText: this.$t('covers.view.vehicle.table.no_data'),
            },
        };
    },
    computed: {
        getColumns() {
            return [
                {
                    title: this.$t('covers.view.vehicle.table.headers.chassis_number'),
                    key: 'chassis_number',
                    dataIndex: 'chassis_number',
                },
                {
                    title: this.$t('covers.view.vehicle.table.headers.registration_number'),
                    key: 'registration_number',
                    dataIndex: 'registration_number',
                },
                {
                    title: this.$t('covers.view.vehicle.table.headers.engine_number'),
                    key: 'engine_number',
                    dataIndex: 'engine_number',
                },
                {
                    title: this.$t('covers.view.vehicle.table.headers.vehicle_usage'),
                    key: 'vehicle_usage',
                    dataIndex: 'vehicle_usage',
                },
                {
                    title: this.$t('covers.view.vehicle.table.headers.vehicle_year'),
                    key: 'vehicle_year',
                    dataIndex: 'vehicle_year',
                },
                {
                    title: this.$t('covers.view.vehicle.table.headers.vehicle_make'),
                    key: 'vehicle_make',
                    dataIndex: 'vehicle_make',
                },
                {
                    title: this.$t('covers.view.vehicle.table.headers.vehicle_model'),
                    key: 'vehicle_model',
                    dataIndex: 'vehicle_model',
                },
            ];
        },
    },
};
</script>
